import axios from "axios";

export function validationCpf(value) {
    
    // Opcional, pode ser nulo ou blank
    if (value == undefined || value == ""){
        return true
    }

    if (typeof value !== 'string') {
        return false;
    }
       
    value = value.replace(/[^\d]+/g, '');
      
    if (value.length !== 11 || !!value.match(/(\d)\1{10}/)) {
        return false;
    }

    if (value.length !== 11 || !Array.from(value).filter(e => e !== value[0]).length) {
        return false
    }
    
    const values = value.split('').map(el => +el);
    const rest = (count) => (values.slice(0, count-12).reduce( (soma, el, index) => (soma + el * (count-index)), 0 )*10) % 11 % 10;
    
    return (rest(10) === values[9] && rest(11) === values[10]);

}

export function validationEmail(email) {
    // Expressão regular para validar o formato do email
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

export function validationBirthDate(value){
    console.log(value);
    return true;
}

export function calcularIdadeEmDias(dataDeNascimento) {
    try {
      // Data atual
      const hoje = new Date();
  
      // Converter as datas para o formato de timestamp em milissegundos
      const dataDeNascimentoTimestamp = dataDeNascimento.getTime();
      const hojeTimestamp = hoje.getTime();
  
      // Calcular a diferença em milissegundos
      const diferencaEmMilissegundos = hojeTimestamp - dataDeNascimentoTimestamp;
  
      // Converter a diferença de milissegundos para dias
      const diasDeDiferenca = diferencaEmMilissegundos / (1000 * 3600 * 24);
  
      return Math.floor(diasDeDiferenca);
    } catch (error) {
      console.error('Ocorreu um erro ao calcular a idade:', error);
      return 0; // Ou outra forma de lidar com o erro, como lançar uma exceção
    }
  }

export function validarCertidaoNascimento(number){
  return true;
}

export function validarPassaporte(number){
  return true;
}

export function base64ToFile(dataImage) {
    if (dataImage?.file && dataImage?.name){
        const contentType = dataImage.file.split(';')[0].split(':')[1];
        const byteCharacters = atob(dataImage.file.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        const file = new File([blob], dataImage.name, { type: contentType });
        return file;
    }
}
//Pega o endereço no VIACEP usando o CEP digitado
async function getAddress(cep, setDataClient, setError){
  try{

     setError('cep', 'Carregando...')
     const response = await axios.get( `https://viacep.com.br/ws/${cep}/json/`
     );
     var jsonResponse = response.data;
     if (jsonResponse.erro){
         setDataClient((d) => ({...d, 'logradouro':'', 'bairro': '',
             'cidade':'', 'uf':''}))
         setError('cep',"CEP não encontrado")
     }
     else{
         setDataClient((d) => ({...d, 'logradouro':jsonResponse.logradouro,
         'bairro': jsonResponse.bairro, 'cidade':jsonResponse.localidade,
         'uf':jsonResponse.uf}))
         setError('cep',null)
     }
 } catch (error) {
   console.error(error);
   setError('cep',"Erro ao buscar CEP")
   setDataClient((d) => ({...d, 'logradouro':'', 'bairro': '', 'cidade':'',
         'uf':''}))
 };
}


export { getAddress };